import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
import { db } from '../../db/db-dexie'

const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const FunctionsService = {

    async Get() { return await methods.Get("Functions/Get"); },
    async Migrar(qs) { return await methods.Get("Functions/Migrar" + useParamsJson(qs)); },
    async List() {
        const result = await FunctionsService.Get();
        if (result && (result.code === '1' || result.code === 1) && result.payload) {
            const data = JSON.parse(result.payload);
            await db.transaction('rw', db.functions, async () => {
                await db.functions.clear();
                if (Array.isArray(data) && data.length > 0) {
                    await db.functions.bulkPut(data);
                }
            });
            return true;
        } else if (result && (result.code === '0' || result.code === 0)) {
            await db.functions.clear();
            return true;
        }
        return false;
    }
};

export default FunctionsService;